import axios from "axios";
export var Picsum;
(function (Picsum) {
    Picsum.api = {
        list: () => {
            return rest.get('/list', { params: { limit: 8, page: 3 } }).then(response => response.data);
        }
    };
})(Picsum || (Picsum = {}));
const rest = axios.create({
    baseURL: 'https://picsum.photos/v2',
});
